var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_21814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65384 3.09561L13.9045 7.34628L4.67436 16.5764L0.88456 16.9948C0.377216 17.0509 -0.0514363 16.6219 0.00500904 16.1146L0.426689 12.3221L9.65384 3.09561ZM16.5335 2.46276L14.5377 0.466919C13.9151 -0.15564 12.9054 -0.15564 12.2829 0.466919L10.4052 2.34456L14.6559 6.59522L16.5335 4.71758C17.1561 4.09469 17.1561 3.08532 16.5335 2.46276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_21814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.bdbd853e37d55fe84fdef0051900489d.svg";
export { ForwardRef as ReactComponent };